import { FormControl, Grid, SelectChangeEvent } from '@mui/material';
import { IComponentCss, MultipleSelect } from '@tap/mui-ui';
import { UseDepartmentState } from './useDepartment';

export type ManufactureAndSectorMultiSelectValue = {
    manufactories: string[],
    departmentIds: number[],
    sectors: string[],
};

export type ManufactureAndSectorMultiSelectProps = UseDepartmentState & {
    value: ManufactureAndSectorMultiSelectValue,
    onChange?: (newValue: ManufactureAndSectorMultiSelectValue) => void,
};


// Для выпадающих списков - выводит количество выбранных элементов
const renderSelectValue = (
    label: string,
    arrayOfElements: any[] | undefined,
    arrayOfSelectedElements: any[] | undefined,
): string => {
    // состояние: все
    if (
        (arrayOfSelectedElements?.length === 0)
        || (arrayOfSelectedElements?.length === arrayOfElements?.length)
    )
        return label + ': все'
    else
        return label + ': ' + arrayOfSelectedElements?.length + '/' + arrayOfElements?.length
};

const css: IComponentCss = {
    select: {
        backgroundColor: '#ffffff',
    },
}


export const ManufactureMultiSelect = ({
    manufactoryList,
    sectorList,
    value,
    onChange,
}: ManufactureAndSectorMultiSelectProps) => {

    const handleChangeSelectedManufactories = (e: SelectChangeEvent<string[]>) => {
        const manufactoryNames = e.target.value as string[];
        const selectedSectors = sectorList
            .filter(s => (!manufactoryNames?.length || manufactoryNames.includes(s.manufactory))
                && value.departmentIds.includes(s.departmentId));

        onChange && onChange({
            manufactories: manufactoryNames,
            sectors: selectedSectors.map(s => s.fullName),
            departmentIds: selectedSectors.map(s => s.departmentId),
        });
    };

    return (
        <MultipleSelect
            options={manufactoryList}
            value={value.manufactories}
            getOptionKey={(item) => item.name}
            getOptionValue={(item) => item.name}
            renderOption={(item) => item.name}
            onChange={handleChangeSelectedManufactories}
            renderValue={() =>
                renderSelectValue(
                    'Цеха',
                    manufactoryList,
                    value.manufactories,
                )}
        />
    );
}

export const SectorMultiSelect = ({
    sectorList,
    value,
    onChange,
}: ManufactureAndSectorMultiSelectProps) => {
    const handleChangeSelectedDepartmentIds = (e: SelectChangeEvent<number[]>) => {
        const selectedDepartmentIds = e.target.value as number[];
        const selectedSectors = sectorList.filter(s => selectedDepartmentIds.includes(s.departmentId));

        onChange && onChange({
            manufactories: value.manufactories,
            sectors: selectedSectors.map(s => s.fullName),
            departmentIds: selectedSectors.map(s => s.departmentId),
        });
    };

    const visibleOptions = sectorList.filter(s => !value.manufactories?.length || value.manufactories.includes(s.manufactory));


    return (
        <MultipleSelect
            options={visibleOptions}
            value={value.departmentIds}
            getOptionKey={(item) => item.departmentId}
            getOptionValue={(item) => item.departmentId}
            renderOption={(item) => item.fullName}
            onChange={handleChangeSelectedDepartmentIds}
            renderValue={() =>
                renderSelectValue(
                    'Участки',
                    visibleOptions,
                    value.departmentIds,
                )}
        />
    );

}


export const ManufactureAndSectorMultiSelect = (props: ManufactureAndSectorMultiSelectProps) => {
    return (

        <Grid container
            item
            spacing={1}>

            {/* Выпадающий список: Цеха */}
            <Grid container
                item
                xs={12}
                sm={12}
                md={6}>
                <FormControl fullWidth sx={css.select}>
                    <ManufactureMultiSelect {...props} />
                </FormControl>
            </Grid>

            {/* Выпадающий список: Участки */}
            <Grid container
                item
                xs={12}
                sm={12}
                md={6}>
                <FormControl fullWidth sx={css.select}>
                    <SectorMultiSelect {...props} />
                </FormControl>
            </Grid>
        </Grid>
    );
}